[
  {
    "code": "HR-07",
    "name": "Bjelovarsko-bilogorska županija"
  },
  {
    "code": "HR-12",
    "name": "Brodsko-posavska županija"
  },
  {
    "code": "HR-19",
    "name": "Dubrovacko-neretvanska županija"
  },
  {
    "code": "HR-21",
    "name": "Grad Zagreb"
  },
  {
    "code": "HR-18",
    "name": "Istarska županija"
  },
  {
    "code": "HR-04",
    "name": "Karlovacka županija"
  },
  {
    "code": "HR-06",
    "name": "Koprivnicko-križevacka županija"
  },
  {
    "code": "HR-02",
    "name": "Krapinsko-zagorska županija"
  },
  {
    "code": "HR-09",
    "name": "Licko-senjska županija"
  },
  {
    "code": "HR-20",
    "name": "Medimurska županija"
  },
  {
    "code": "HR-14",
    "name": "Osjecko-baranjska županija"
  },
  {
    "code": "HR-11",
    "name": "Požeško-slavonska županija"
  },
  {
    "code": "HR-08",
    "name": "Primorsko-goranska županija"
  },
  {
    "code": "HR-03",
    "name": "Sisacko-moslavacka županija"
  },
  {
    "code": "HR-17",
    "name": "Splitsko-dalmatinska županija"
  },
  {
    "code": "HR-05",
    "name": "Varaždinska županija"
  },
  {
    "code": "HR-10",
    "name": "Viroviticko-podravska županija"
  },
  {
    "code": "HR-16",
    "name": "Vukovarsko-srijemska županija"
  },
  {
    "code": "HR-13",
    "name": "Zadarska županija"
  },
  {
    "code": "HR-01",
    "name": "Zagrebacka županija"
  },
  {
    "code": "HR-15",
    "name": "Šibensko-kninska županija"
  }
]